import { render, staticRenderFns } from "./TeacherResourse.vue?vue&type=template&id=1992374a&scoped=true"
import script from "./TeacherResourse.vue?vue&type=script&lang=js"
export * from "./TeacherResourse.vue?vue&type=script&lang=js"
import style0 from "./TeacherResourse.vue?vue&type=style&index=0&id=1992374a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1992374a",
  null
  
)

export default component.exports